<script>
	import {onMount} from 'svelte';
let chatbox;
let liveChatting;
onMount(liveChat);
/**
 *
 */
function liveChat() {
    chatbox = liveChatting;
    chatbox.setAttribute('page_id', '267859313332483');
    chatbox.setAttribute('attribution', 'biz_inbox');
    window.fbAsyncInit = function() {
        FB.init({
            xfbml: true,
            version: 'v15.0',
        });
    };
    (function(d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        const js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}
</script>

<!-- Messenger Chat Plugin Code -->
<div id="fb-root"></div>
<!-- Your Chat Plugin code -->
<div bind:this={liveChatting} class="fb-customerchat"></div>